module.exports = __webpack_public_path__ + "static/media/f_eyeshape_downturned_lightbrown.ddb0ab86.png";